import { useEffect, useRef } from "react";

interface AttachableTrack {
  attach(element: HTMLMediaElement): HTMLMediaElement;
  detach(element: HTMLMediaElement): HTMLMediaElement;
}

/**
 * Attaches a Twilio media track to a media element for its lifetime.
 * Returns the ref to place on the <video>/<audio> element.
 */
export const useTrackAttachment = <T extends HTMLMediaElement>(track: AttachableTrack | null | undefined) => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const el = ref.current;
    if (!track || !el) return;
    track.attach(el);
    return () => {
      track.detach(el);
    };
  }, [track]);

  return ref;
};
